<template>
	<div class="cnt-antecipacao">
		<div class="row">
			<div class="col-sm-6">
				<b class="title">IMAGENS DO SETOR</b>
				<div class="row">
					<div v-if="data.imagens != undefined" class="col-sm-9">
						<div
							class="img-active img-thumbnail"
							:title="data.imagens[pImg].title"
							:style="{
								'background-image': `url(${base}${data.imagens[pImg].url})`,
							}"
						></div>
					</div>
					<div
						v-if="
							data.imagens == undefined ||
							data.imagens.length == 0
						"
						class="col-sm-12 msg"
					>
						<i class="fa fa-warning"></i>
						<span>Nenhum imagem enviada</span>
					</div>
					<div v-else class="col-sm-3">
						<div
							v-for="(n, id) in data.imagens"
							:title="n.title"
							:style="{
								'background-image': `url(${base}${n.url})`,
							}"
							@click="pImg = id"
							class="img-mini img-thumbnail"
						></div>
					</div>
				</div>
			</div>
			<div class="col-sm-6">
				<b class="title">Descrição do setor</b>
				<textarea
					v-model="data.descricao"
					rows="5"
					class="form-control"
				></textarea>
				<br />
				<b class="title">
					mapeamento
					<span class="pull-right" :class="{ 'mrg-right': true }">
						<span>h</span>
						<span>m</span>
					</span>
				</b>
				<nav class="map-table">
					<li
						v-for="(n, index) in data.funcoes"
						:key="index"
						:title="n.funcao"
					>
						<ul>
							{{
								n.funcao
							}}
						</ul>
						<ul>
							{{
								n.masculino
							}}
						</ul>
						<ul>
							{{
								n.feminino
							}}
						</ul>
						<div class="clearfix"></div>
					</li>
				</nav>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'CmpAntecipacao',
		props: ['dIn'],
		data() {
			return {
				base: 'http://wbs.viasst.com.br/uploaded_files/img-setor/',
				pImg: 0,
			};
		},
		computed: {
			data() {
				return this.dIn;
			},
		},
	};
</script>
<style scoped>
	.msg {
		padding: 108px 0px;
	}
	.msg i {
		font-size: 40px;
		text-align: center;
		display: block;
	}
	.msg span {
		font-size: 25px;
		display: block;
		text-align: center;
	}
	.mrg-right {
		margin-right: 16px;
	}
	.pull-right {
		width: 20%;
	}
	.pull-right span {
		padding: 0px 10px;
		width: 50%;
		float: left;
		display: block;
		text-align: center;
	}
	.map-table {
		display: block;
		width: 100%;
		height: 172px;
		overflow: auto;
	}
	.map-table li {
		list-style: none;
		border-bottom: 1px solid #cecece;
	}
	.map-table li:nth-child(1) {
		border-top: 1px solid #cecece;
	}
	.map-table li:nth-child(2n) {
		background-color: rgba(206, 206, 206, 0.42);
	}
	.map-table li ul {
		margin: 0px;
		padding: 5px 10px;
		display: block;
		box-sizing: border-box;
		float: left;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	.map-table li ul:nth-child(1) {
		width: 80%;
		border-right: 1px solid #cecece;
		border-left: 1px solid #cecece;
	}
	.map-table li ul:nth-child(2),
	.map-table li ul:nth-child(3) {
		width: 10%;
		text-align: center;
		border-right: 1px solid #cecece;
	}

	b.title {
		text-transform: uppercase;
	}
	.nav-pills a {
		border-radius: 5px;
		cursor: pointer;
		text-transform: uppercase;
	}
	.img-active {
		width: 100%;
		display: block;
		height: 327px;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}
	.img-mini {
		width: 100%;
		height: 78px;
		display: block;
		margin-bottom: 5px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/mapRisco/map-components/antecipacao.vue